/**
 * Centralized workflow configuration for literature review pages
 */

export const WORKFLOW_STEPS = [
  {
    id: "paper-sources",
    label: "Article selection",
    route: "/screening",
  },
  {
    id: "abstract-screening",
    label: "Abstract screening",
    route: "/screening",
  },
  {
    id: "recommended-abstracts",
    label: "Recommended Abstracts",
    route: "/screening",
  },
  {
    id: "full-text-screening",
    label: "Full-text screening",
    route: "/screening",
  },
  {
    id: "recommended-sources",
    label: "Recommended Sources",
    route: "/screening",
  },
  {
    id: "data-extraction-definition",
    label: "Data Extraction",
    route: "/screening",
  },
  {
    id: "data-extraction-results",
    label: "Extraction results",
    route: "/screening",
  },
  {
    id: "research-report",
    label: "Research report",
    route: "/screening",
  },
];

export const getWorkflowSteps = (currentStepId, completedStepIds = []) => {
  return WORKFLOW_STEPS.map((step) => {
    const stepIndex = WORKFLOW_STEPS.findIndex((s) => s.id === step.id);
    const currentStepIndex = WORKFLOW_STEPS.findIndex(
      (s) => s.id === currentStepId
    );

    return {
      ...step,
      isActive: step.id === currentStepId,
      isCompleted:
        completedStepIds.includes(step.id) ||
        (stepIndex < currentStepIndex && currentStepIndex !== -1),
    };
  });
};

// gets the next workflow step
export const getNextStep = (currentStepId) => {
  const currentIndex = WORKFLOW_STEPS.findIndex((s) => s.id === currentStepId);
  if (currentIndex === -1 || currentIndex === WORKFLOW_STEPS.length - 1) {
    return null;
  }
  return WORKFLOW_STEPS[currentIndex + 1];
};

// Gets the previous step in the workflow
export const getPreviousStep = (currentStepId) => {
  const currentIndex = WORKFLOW_STEPS.findIndex((s) => s.id === currentStepId);
  if (currentIndex === -1 || currentIndex === 0) {
    return null;
  }
  return WORKFLOW_STEPS[currentIndex - 1];
};

export const getDefaultStepId = () =>
  WORKFLOW_STEPS[0]?.id ?? "paper-sources";

const validStepIds = new Set(WORKFLOW_STEPS.map((s) => s.id));

export const getStepIdFromHash = (hash) => {
  const stepId = hash ? hash.replace(/^#/, "").trim() : "";
  return stepId && validStepIds.has(stepId) ? stepId : null;
};

const SCREENING_STEP_KEY = "screening-step";

export const getPersistedStep = (reviewId) => {
  if (typeof window === "undefined" || !reviewId) return null;
  try {
    const stored = localStorage.getItem(`${SCREENING_STEP_KEY}-${reviewId}`);
    return stored && validStepIds.has(stored) ? stored : null;
  } catch {
    return null;
  }
};

export const persistStep = (reviewId, stepId) => {
  if (typeof window === "undefined" || !reviewId || !stepId) return;
  try {
    localStorage.setItem(`${SCREENING_STEP_KEY}-${reviewId}`, stepId);
  } catch (_) { }
};

const FROM_STEP_STORAGE_KEY = "screening-from-step";

export const getStoredFromStep = (reviewId) => {
  if (typeof window === "undefined" || !reviewId) return null;
  try {
    return localStorage.getItem(`${FROM_STEP_STORAGE_KEY}-${reviewId}`);
  } catch {
    return null;
  }
};

export const setStoredFromStep = (reviewId, fromStep) => {
  if (typeof window === "undefined" || !reviewId || !fromStep) return;
  try {
    localStorage.setItem(`${FROM_STEP_STORAGE_KEY}-${reviewId}`, fromStep);
  } catch (_) { }
};
